
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.583 1.473a.759.759 0 00-1.166 0L9.612 3.704a.757.757 0 01-.79.245l-2.834-.792c-.463-.13-.93.193-.944.654l-.086 2.817a.707.707 0 01-.488.641l-2.78.949c-.455.155-.633.678-.361 1.058l1.665 2.328a.676.676 0 010 .792L1.33 14.724c-.272.38-.094.903.36 1.058l2.781.949c.286.097.48.352.488.641l.086 2.817c.014.46.48.784.944.654l2.834-.792a.757.757 0 01.79.245l1.805 2.23a.759.759 0 001.166 0l1.805-2.23c.185-.23.499-.327.79-.245l2.834.792c.463.13.93-.194.944-.654l.086-2.817a.707.707 0 01.488-.641l2.781-.949c.454-.155.633-.678.36-1.058l-1.665-2.328a.677.677 0 010-.793l1.665-2.327c.273-.38.094-.903-.36-1.058l-2.781-.949a.707.707 0 01-.488-.641l-.086-2.817c-.014-.46-.48-.784-.944-.654l-2.834.792a.757.757 0 01-.79-.245l-1.805-2.23zm2.714 7.054l-4.974 4.863-1.614-1.58a.822.822 0 00-1.136-.001.734.734 0 00-.002 1.06l2.068 2.025a.988.988 0 001.369 0l5.424-5.31c.3-.293.3-.762 0-1.056a.82.82 0 00-1.135 0z","fill":"#33C173"}})])
          )
        }
      }
    